import React from 'react';
interface LabelProps {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
  className?: string;
}
export function Label({
  children,
  tone = 'dark',
  className = ''
}: LabelProps) {
  return <p className={`flex items-center gap-4 text-[11px] font-medium uppercase tracking-[0.34em] ${tone === 'dark' ? 'text-brass' : 'text-brass'} ${className}`} data-id="element-157" data-mp="3a3raqepzy4an">
      <span className={`h-px w-10 ${tone === 'dark' ? 'bg-brass/60' : 'bg-brass/60'}`} aria-hidden="true" data-id="element-158" data-mp="3k15p88sd0j0b" />
      {children}
    </p>;
}